import { DeviationTypes } from '../../types/deviation';
function toSrcFile(file) {
    if (!file) {
        return undefined;
    }
    return {
        type: file.type,
        src: file.src,
        height: file.height,
        width: file.width,
        transparency: file.transparency,
        quality: file.quality,
        filesize: file.filesize,
        duration: file.duration,
        isDefault: file.isDefault,
    };
}
var defaultFullview = {
    type: 'unknown',
    src: '',
    width: 1000,
    height: 1000,
    isDefault: true,
};
/** @deprecated */
var LegacyMediaHandler = /** @class */ (function () {
    function LegacyMediaHandler() {
    }
    LegacyMediaHandler.prototype.isGif = function (deviation) {
        if (deviation && deviation.isGif) {
            return true;
        }
        if (!deviation.files) {
            return false;
        }
        return deviation.files.find(function (file) { return file.type === 'gif'; }) ? true : false;
    };
    LegacyMediaHandler.prototype.getDeviationType = function (deviation) {
        if (!deviation) {
            return DeviationTypes.UNKNOWN;
        }
        // New type handling backend now defines
        if (deviation.type) {
            return deviation.type;
        }
        // Legacy duck typing below
        // polls
        if (deviation.poll) {
            return DeviationTypes.POLL;
        }
        // commission
        if (deviation.commission) {
            return DeviationTypes.COMMISSION;
        }
        // status
        if (deviation.status) {
            return DeviationTypes.STATUS;
        }
        // Freeform Text (Journal - Status - Literature)
        if (deviation.textContent) {
            if (deviation.isJournal) {
                return DeviationTypes.JOURNAL;
            }
            return DeviationTypes.LITERATURE;
        }
        if (!deviation.files) {
            return DeviationTypes.UNKNOWN;
        }
        var fileTypes = {};
        var defaultFilesCount = 0;
        for (var _i = 0, _a = deviation.files; _i < _a.length; _i++) {
            var file = _a[_i];
            fileTypes[file.type] = true;
            if (file.isDefault) {
                defaultFilesCount++;
            }
        }
        // Video
        if (deviation.isVideo || fileTypes.video) {
            return DeviationTypes.FILM;
        }
        // PDF
        if (fileTypes.pdf) {
            return DeviationTypes.PDF;
        }
        // GIF
        if (fileTypes.gif) {
            return DeviationTypes.IMAGE;
        }
        // Image
        if (defaultFilesCount !== deviation.files.length) {
            return DeviationTypes.IMAGE;
        }
        return DeviationTypes.UNKNOWN;
    };
    LegacyMediaHandler.prototype.getSmallestThumb = function (deviation, options) {
        var thumbs = this.getThumbSet(deviation, options);
        if (!thumbs) {
            return;
        }
        var small = this._getThumbsSortedSmallToBig(thumbs)[0];
        return toSrcFile(small);
    };
    LegacyMediaHandler.prototype.getSmallestThumbThatFullyCovers = function (deviation, width, height, fallback, options) {
        var thumbs = this.getThumbSet(deviation, options);
        if (!thumbs) {
            return;
        }
        // Allow slightly smaller than the requested block, the scaling
        // rules allow for 25%~ smaller to be scaled up so make this match
        // those. We force portraits to match the width.
        var allowedWidth = width; // * 0.85;
        var allowedHeight = height; // * 0.85;
        if (width < height) {
            allowedWidth = width;
        }
        var smallest = this._getThumbsSortedSmallToBig(thumbs).find(function (img) {
            var _a = img.width, imgWidth = _a === void 0 ? 0 : _a, _b = img.height, imgHeight = _b === void 0 ? 0 : _b;
            return imgWidth >= allowedWidth && imgHeight >= allowedHeight;
        });
        // Allow caller to determine the fallback
        if (!smallest && fallback) {
            return fallback(thumbs);
        }
        return smallest && toSrcFile(smallest);
    };
    LegacyMediaHandler.prototype.getLargestFullview = function (deviation) {
        var type = this.getDeviationType(deviation);
        if (type === DeviationTypes.JOURNAL || type === DeviationTypes.LITERATURE) {
            return defaultFullview;
        }
        return this._getLargestFullview(deviation);
    };
    LegacyMediaHandler.prototype.getThumbDimensions = function (deviation) {
        var fv = this._getLargestFullview(deviation);
        var type = this.getDeviationType(deviation);
        var defaultDimensions = { width: 1000, height: 1000 };
        if (type === DeviationTypes.TIER) {
            return { width: 1840, height: 1000 };
        }
        if (!fv ||
            !fv.width ||
            !fv.height ||
            [
                DeviationTypes.JOURNAL,
                DeviationTypes.LITERATURE,
                DeviationTypes.STATUS,
                DeviationTypes.COMMISSION,
            ].includes(type)) {
            return defaultDimensions;
        }
        return { width: fv.width, height: fv.height };
    };
    LegacyMediaHandler.prototype.getFullviewForSize = function (deviation, width, height) {
        var _this = this;
        var fullviews = this._getFullviews(deviation);
        if (!fullviews.length) {
            return;
        }
        // sort by resolution small to big
        fullviews.sort(function (a, b) { return _this._getFilePixelSize(a) - _this._getFilePixelSize(b); });
        // find smallest fitting file
        if (width && height) {
            var file = fullviews.find(function (f) {
                if (!f.width || !f.height) {
                    return false;
                }
                return f.width >= width && f.height >= height;
            });
            if (file) {
                return toSrcFile(file);
            }
        }
        // if no fitting file was found return largest one
        return toSrcFile(fullviews[fullviews.length - 1]);
    };
    LegacyMediaHandler.prototype.getDeviationFile = function (deviation, fileType) {
        var files = deviation && deviation.files;
        var file = files && files.find(function (f) { return f.type === fileType; });
        if (file) {
            return toSrcFile(file);
        }
        return undefined;
    };
    LegacyMediaHandler.prototype.getThumbSet = function (deviation, options) {
        var thumbFileTypes = [
            '150',
            '200H',
            '300W',
            '200T',
            '250T',
            '350T',
            '400T',
            '375W',
            '414W',
            '750W',
            '828W',
        ];
        // Check if this deviation may be compressed by the editor, in this
        // case we can have reduced files array and need to allow
        if (this._mightBeCompressedFilesList(deviation)) {
            thumbFileTypes.push('preview', 'fullview', 'gif');
        }
        if (options && options.allowPreview) {
            thumbFileTypes.push('preview');
        }
        if (options && options.allowFullview) {
            thumbFileTypes.push('fullview');
            thumbFileTypes.push('fullview_unpublished');
        }
        if (options && options.allowSquareCrop) {
            thumbFileTypes.push('92S');
        }
        if (!deviation || !deviation.files) {
            return [];
        }
        return deviation.files.filter(function (file) { return !file.isDefault && thumbFileTypes.includes(file.type); });
    };
    LegacyMediaHandler.prototype.getMediaByType = function (deviation, fileType) {
        if (!deviation || !deviation.files || !Array.isArray(deviation.files)) {
            return [];
        }
        return deviation.files.filter(function (file) { return file && file.type === fileType; });
    };
    LegacyMediaHandler.prototype._getFullviews = function (deviation) {
        if (!deviation || !deviation.files) {
            return [];
        }
        var files = deviation && deviation.files;
        // for gif images only the gif file is a valid fullview
        var gif = files && files.find(function (f) { return f.type === 'gif'; });
        if (gif) {
            return [gif];
        }
        return files.filter(function (file) { return file && /^fullview|preview|original/.test(file.type); });
    };
    LegacyMediaHandler.prototype._getFilePixelSize = function (file) {
        return (file.width || 0) * (file.height || 0);
    };
    LegacyMediaHandler.prototype._getThumbsSortedSmallToBig = function (thumbs) {
        if (!thumbs) {
            return [];
        }
        return thumbs.sort(function (a, b) {
            var asc = (a.width || 0) * (a.height || 0);
            var bsc = (b.width || 0) * (b.height || 0);
            if (asc === bsc) {
                return 0;
            }
            return asc < bsc ? -1 : 1;
        });
    };
    LegacyMediaHandler.prototype._mightBeCompressedFilesList = function (deviation) {
        if (!deviation || !deviation.files) {
            return false;
        }
        // Assume single file whatever it is to be safe
        if (deviation.files.length === 1) {
            return true;
        }
        var types = deviation.files.map(function (f) { return f.type; });
        // social_preview bug T38231
        if (types.length === 2 &&
            types.includes('fullview') &&
            types.includes('social_preview')) {
            return true;
        }
        return false;
    };
    LegacyMediaHandler.prototype._getLargestFullview = function (deviation) {
        var fvs = this._getFullviews(deviation);
        if (fvs.length === 0) {
            return defaultFullview;
        }
        var fv = fvs.reduce(function (prev, curr) {
            if ((prev.width || 0) > (curr.width || 0) ||
                (prev.height || 0) > (curr.height || 0)) {
                return prev;
            }
            return curr;
        });
        return (fv && toSrcFile(fv)) || defaultFullview;
    };
    return LegacyMediaHandler;
}());
export default LegacyMediaHandler;
//# sourceMappingURL=LegacyHandler.js.map